import Table, { ColumnsType } from "antd/lib/table";
import { Modal, Tag } from "antd";
import Draggable from "react-draggable";
import { MobileOutlined } from "@ant-design/icons";

import { TableHelper } from "../../../util/TableHelper";
import Loading from "../../common/Loading";
import styles from "./index.module.less";
import { useVisitorUserList } from "./index.hook";
import { useReactDraggable } from "../../../hooks/useReactDraggable";

import type { GetAllMobileUserResponse } from "../../../shared/interface/UserManagement/mobileUser.interface";

const VisitorUserList = (props: { searchedText: string }) => {
  const config = useVisitorUserList({ searchedText: props.searchedText });

  const { bounds, onStart } = useReactDraggable();

  const columns: ColumnsType<GetAllMobileUserResponse> = [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: TableHelper.renderNumberValue,
      sorter: {
        compare: TableHelper.valueCompare("sr_no")
      },
      width: "7%"
    },
    {
      align: "left",
      title: "Full Name",
      dataIndex: "full_name",
      key: "full_name",
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "space-between" }} className={record?.id === config?.userId ? styles["modal__description"] : undefined}>
          <span style={{ wordWrap: "break-word", wordBreak: "break-word" }}>{TableHelper.getValue(text)}</span>
          <span>{record?.fcmTokenList?.length > 0 && <MobileOutlined />}</span>
        </div>
      ),
      sorter: {
        compare: TableHelper.valueCompare("full_name")
      }
    },
    {
      align: "center",
      title: "Mobile Number",
      dataIndex: "mobile_number",
      render: TableHelper.renderText,
      sorter: {
        compare: TableHelper.valueCompare("mobile_number")
      }
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: (a, b) => (a.is_active === false ? -1 : 1),
      render: (text) => <div className="table-text-wrap">{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    }
  ];

  return (
    <div>
      {config?.loading && <Loading />}

      {!config?.loading && <Table className="gx-table-responsive" size="small" columns={columns} dataSource={config?.filteredTableData} pagination={config?.pagination} onChange={config?.handleChangePagination} rowKey={(record) => record.sr_no} bordered />}

      <Modal
        title={<div className="modal-container">Active/In-Active Confirmation</div>}
        open={config?.showDeleteModal}
        onCancel={config.handleCancel}
        onOk={config.handleOk}
        okText="Yes"
        cancelText="No"
        width="580px"
        destroyOnClose
        maskClosable={false}
        wrapClassName="delete-modal"
        modalRender={(modal) => (
          <Draggable bounds={bounds} handle=".ant-modal-header" onStart={(event, uiData) => onStart(event as any, uiData)}>
            {modal}
          </Draggable>
        )}
        okButtonProps={{
          disabled: config?.saving,
          loading: config?.saving
        }}
      >
        <h4>
          {`Are you sure you want to ${config.isActive ? "inactivate" : "activate"} the account for visitor user`} <span className={styles["modal__description"]}>{config.userName}</span>?
        </h4>
      </Modal>
    </div>
  );
};

export default VisitorUserList;
